import {
    DropdownButton,
    DropdownItem,
    FormControl,
    FormGroup,
    Nav,
    OffcanvasNavbar
} from 'boot-cell';
import { JsxChildren } from 'dom-renderer';
import { FC, observer, PropsWithChildren } from 'web-cell';

import userStore from '../model/User';
import defaultMenu from '../page/menu.json';
import { IconNavLink, IconNavLinkProps } from './IconNavLink';
import * as styles from './PageFrame.module.less';

interface MenuSection {
    title?: JsxChildren;
    list: Pick<IconNavLinkProps, 'title' | 'href' | 'icon'>[];
}

export type PageFrameProps = PropsWithChildren<{
    menu?: MenuSection[];
}>;

export const PageFrame: FC<PageFrameProps> = observer(
    ({ menu = defaultMenu, children }) => (
        <div>
            <OffcanvasNavbar
                variant="dark"
                fluid
                expand="md"
                brand={
                    <img
                        style={{ width: '2rem' }}
                        alt="ALTAI platform"
                        src="https://github.com/RMinte.png"
                    />
                }
            >
                <div className="row align-items-center w-100 ms-auto g-3">
                    <FormGroup className="col-md-3 offset-md-4 offset-lg-6">
                        <FormControl
                            as="input"
                            type="search"
                            required
                            placeholder="Search"
                        />
                    </FormGroup>
                    <FormGroup className="col-md-2 text-end">
                        <DropdownButton
                            caption={userStore.session?.email}
                            variant="secondary"
                            size="sm"
                        >
                            <DropdownItem onClick={userStore.signOut}>
                                Sign out
                            </DropdownItem>
                        </DropdownButton>
                    </FormGroup>
                </div>
            </OffcanvasNavbar>

            <div className={styles.body}>
                <Nav className="flex-column py-2 border-right">
                    {menu.map(({ title, list }) => (
                        <>
                            {title && (
                                <h6 className="text-muted mx-3 mt-4 d-none d-md-block">
                                    {title}
                                </h6>
                            )}
                            {list.map(({ title, href, icon }) => (
                                <IconNavLink
                                    key={title}
                                    className="text-nowrap"
                                    href={`#${href}`}
                                    icon={icon}
                                >
                                    {title}
                                </IconNavLink>
                            ))}
                        </>
                    ))}
                </Nav>
                <main className="flex-fill h-100 p-4 overflow-auto">
                    {children}
                </main>
            </div>
        </div>
    )
);
